import React from 'react';
import { Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { setNotes } from '@store/policies/schedule/actions';
import { formModes } from '@store/policies/schedule/formReducer';
import { actOptions } from '@store/policies/schedule/utils';
import { FieldWrapper } from './styled';

const { TextArea } = Input;

function Notes() {
  const dispatch = useDispatch();
  const { activationState, mode, notes, reorderState } = useSelector(formViewSelector);

  const handleChange = (e) => {
    dispatch(setNotes(e.target.value));
  };

  return activationState === actOptions.schedule ? (
    <FieldWrapper>
      <TextArea
        rows={4}
        placeholder="Notes"
        defaultValue={notes}
        onChange={handleChange}
        disabled={mode === formModes.delete}
      />
    </FieldWrapper>
  ) : null;
}

export default React.memo(Notes);
